import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["labelStart", "labelAscending", "labelDescending", "sortDirection"];
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Arrow = styled('polygon').withConfig({
  displayName: "SortArrows__Arrow",
  componentId: "sc-1720814-0"
})(["fill:", ";"], ({
  theme,
  selected
}) => selected ? theme.color['icon-interactive-default'] : 'currentColor');
const SortArrowsWrapper = styled.span.withConfig({
  displayName: "SortArrows__SortArrowsWrapper",
  componentId: "sc-1720814-1"
})(["display:inline-block;color:", ";fill:currentColor;flex-shrink:0;inline-size:7.5px;line-height:1;"], ({
  theme
}) => theme.color['icon-core-subtle']);
export const SortArrows = _ref => {
  let {
      labelStart = 'Press to sort.',
      labelAscending = 'Ascending sort. Press to sort descending.',
      labelDescending = 'Descending sort. Press to sort ascending.',
      sortDirection
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  let ariaLabel = labelStart;
  if (sortDirection === 'ascending') {
    ariaLabel = labelAscending;
  } else if (sortDirection === 'descending') {
    ariaLabel = labelDescending;
  }
  return /*#__PURE__*/_jsx(SortArrowsWrapper, Object.assign({
    "aria-label": ariaLabel,
    "aria-live": "polite"
  }, rest, {
    children: /*#__PURE__*/_jsxs("svg", {
      role: "presentation",
      viewBox: "0 0 7.5 14",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx(Arrow, {
        points: "7.5 5 0 5 3.75 0 7.5 5",
        selected: sortDirection === 'ascending'
      }), /*#__PURE__*/_jsx(Arrow, {
        points: "0 9 7.5 9 3.75 14 0 9",
        selected: sortDirection === 'descending'
      })]
    })
  }));
};